import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { TokenStoreService } from '@services/token-store.service';
import { AuthService, ParsedUser } from '@services/auth.service';


export const disputeCanActivate: CanActivateFn = async (route): Promise<boolean | UrlTree> => {
  const tokenStore = inject(TokenStoreService);
  const authService = inject(AuthService);

  const token: string = await tokenStore.getToken();

  if (!token) return true;

  if (route.routeConfig?.path?.includes('/tasks/dispute/')) return true;

  const parsedUser: ParsedUser = authService.parsedUser;

  if (parsedUser?.replyOnResolveDispute?.hasReplyOnResolveDispute) {
    return inject(Router).createUrlTree([
      '/tasks/dispute',
      parsedUser.replyOnResolveDispute.taskId,
      'details',
    ]);
  }

  return true;
};
